/* Teng Tools USA — Click & Fill configurator (our own build, 2026-07-10).
   Replaces the vendored corporate bundle. Self-contained: no Tailwind, no
   theme-class dependency; all UI under .cf-app / #cf-root.
   Geometry model: every drawer is a slot grid — columns of 142mm, and one or
   two depth bands (back 264mm + front 115mm on 379mm drawers). Every tray in
   the catalogue occupies whole columns in one band, or the full drawer depth.
   Data: APP_CONFIG.data.{toolStorages,toolSets,toolKits} + skuMapUrl + imageMap. */
(function () {
  'use strict';

  var COL_MM = 142;
  /* Tool-family classification from set descriptions — mirrors the store nav. */
  var CATS = [
    ['sockets', 'Sockets & Ratchets', /socket|ratchet|extension bar|adaptor|crowfoot/],
    ['keys', 'Hex & TX Keys', /hex key|tx key|t-handle/],
    ['screwdrivers', 'Screwdrivers & Bits', /screwdriver|bits driver|bit set|bits set|driver set/],
    ['wrenches', 'Wrenches', /wrench|torque/],
    ['pliers', 'Pliers & Cutting', /plier|cutter|snip|shear|pincer|grip/],
    ['trays', 'Storage trays', /storage tray|compartment/],
  ];
  function classify(description) {
    var d = String(description || '').toLowerCase();
    for (var i = 0; i < CATS.length; i++) {
      if (CATS[i][2].test(d)) return CATS[i][0];
    }
    return 'specialist';
  }
  var CFG = window.APP_CONFIG || {};
  /* Build attribution id — kickback/rebate claims join on this. Minted once
     per page load, re-minted after "Start over" (see the restart handler in
     buildBar()) so a fresh build never inherits a previous session's id. */
  function mintBuildId() {
    return 'kb-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 6);
  }
  var BUILD_ID = mintBuildId();
  var TRADE_ICONS = { 'automotive-mechanic': '🚗', 'diesel-heavy-equipment': '🚛', 'aviation-technician': '✈️', 'electrician': '⚡', 'industrial-maintenance': '🏭', 'marine-technician': '⚓', 'hvac-technician': '❄️', 'motorsport-technician': '🏁', 'collision-body-repair': '🔨', 'general-maintenance': '🔧', 'ev-technician': '🔋', 'manufacturing-assembly': '⚙️' };
  var S = {
    storages: [], sets: [], kits: [], sku: {}, trades: [], trade: null, tradeMaterial: 'mix', path: null,
    setMap: {}, storageMap: {},
    storage: null, drawers: [],
    openPicker: null, pickerText: '', pickerType: 'all', pickerCat: 'all', pickerSize: 'all', pickerShowAll: false,
    gapTrade: null, gapData: null, bays: 1,
    catText: '', catType: 'all',
    status: '', uid: 1
  };
  var root, bar;

  /* ---------- utils ---------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function num(v) { var n = parseFloat(v); return isFinite(n) ? n : 0; }
  function money(n) {
    return '$' + Number(n).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function img(file) {
    var map = (window.APP_CONFIG || {}).imageMap || {};
    return file && map[file] ? map[file] : null;
  }
  /* Prefer the product image on Shopify's image CDN (resizable on demand,
     like the rest of the store); fall back to the fixed theme asset. */
  function imgTag(itemId, assetFile, px, alt, extra) {
    var e = S.sku[itemId];
    var cdn = e && e.img;
    if (cdn) {
      var sep = cdn.indexOf('?') >= 0 ? '&' : '?';
      var src = cdn + sep + 'width=' + px;
      var src2 = cdn + sep + 'width=' + Math.min(px * 2, 1600);
      return '<img src="' + esc(src) + '" srcset="' + esc(src) + ' 1x, ' + esc(src2) + ' 2x" alt="' + esc(alt || '') + '" loading="lazy"' + (extra || '') + '>';
    }
    var fallback = img(assetFile);
    return fallback ? '<img src="' + esc(fallback) + '" alt="' + esc(alt || '') + '" loading="lazy"' + (extra || '') + '>' : '';
  }
  function priceOf(itemId) { var e = S.sku[itemId]; return e ? num(e.price) : 0; }
  function availOf(itemId) { var e = S.sku[itemId]; return !!e && e.avail !== false; }
  function etaOf(itemId) { var e = S.sku[itemId]; return (e && e.eta) || null; }
  function fmtEta(iso) {
    var d = new Date(iso + 'T00:00:00Z');
    if (isNaN(d.getTime())) return iso;
    return ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'][d.getUTCMonth()] + ' ' + d.getUTCDate();
  }

  /* ---------- drawer + fit model ---------- */
  function splitDims(s2) { return String(s2 == null ? '' : s2).split(';').map(function (x) { return num(x); }); }

  function drawerName(i, n, h) {
    if (n === 1) return 'Drawer';
    if (i === 0) return 'Top drawer';
    if (i === n - 1) return h >= 150 ? 'Deep bottom drawer' : 'Bottom drawer';
    if (n === 3) return 'Middle drawer';
    return 'Drawer ' + (i + 1);
  }

  function bandsFor(depth) {
    if (depth >= 379) return [{ key: 'back', depth: 264 }, { key: 'front', depth: 115 }];
    if (depth >= 264) return [{ key: 'back', depth: 264 }];
    return [{ key: 'front', depth: depth }];
  }

  function buildDrawers(storage) {
    var n = parseInt(storage.numberOfDrawerInStorage, 10) || 0;
    var ws = splitDims(storage.storagePerDrawerWidth);
    var ds = splitDims(storage.storagePerDrawerDepth);
    var hs = splitDims(storage.storagePerDrawerHeight);
    var cs = splitDims(storage.storagePerDrawerCapacity);
    var out = [];
    for (var i = 0; i < n; i++) {
      var w = ws[i] || ws[ws.length - 1] || 568;
      var d = ds[i] || ds[ds.length - 1] || 379;
      var h = hs[i] || hs[hs.length - 1] || 75;
      var cap = cs[i] || cs[cs.length - 1] || 0;
      out.push({
        index: i, name: drawerName(i, n, h),
        w: w, d: d, h: h, capKg: cap,
        cols: Math.max(1, Math.round(w / COL_MM)),
        bands: bandsFor(d),
        placements: []
      });
    }
    return out;
  }

  function footprint(set) {
    var w = num(set.setWidth), d = num(set.setDepth);
    if (!w || !d) return null;
    return { wcols: Math.max(1, Math.round(w / COL_MM)), band: d >= 379 ? 'full' : d >= 264 ? 'back' : 'front' };
  }

  function occupancy(drawer) {
    var occ = {};
    drawer.bands.forEach(function (b) { occ[b.key] = new Array(drawer.cols).fill(false); });
    drawer.placements.forEach(function (p) {
      var keys = p.band === 'full' ? drawer.bands.map(function (b) { return b.key; }) : [p.band];
      keys.forEach(function (k) {
        if (!occ[k]) return;
        for (var c = p.col; c < p.col + p.wcols; c++) occ[k][c] = true;
      });
    });
    return occ;
  }

  function drawerWeightG(drawer) {
    return drawer.placements.reduce(function (t, p) {
      var set = S.setMap[p.itemId];
      return t + (set ? num(set.itemWeight) : 0);
    }, 0);
  }

  function freeSpan(cells, wcols) {
    var run = 0;
    for (var c = 0; c < cells.length; c++) {
      run = cells[c] ? 0 : run + 1;
      if (run >= wcols) return c - wcols + 1;
    }
    return -1;
  }

  /* Returns {col, band} or {reason} */
  function findSlot(drawer, set) {
    var fp = footprint(set);
    if (!fp) return { reason: 'No size data for this set.' };
    if (num(set.setHeight) > drawer.h + 1) return { reason: 'Too tall for this drawer' };
    if (drawer.capKg && (drawerWeightG(drawer) + num(set.itemWeight)) / 1000 > drawer.capKg) {
      return { reason: 'Over this drawer’s ' + drawer.capKg + ' kg limit' };
    }
    var occ = occupancy(drawer);
    if (fp.band === 'full') {
      if (drawer.bands.length < 2) return { reason: 'Needs a full-depth drawer' };
      var merged = occ.back.map(function (v, i) { return v || occ.front[i]; });
      var col = freeSpan(merged, fp.wcols);
      return col < 0 ? { reason: 'No space left in this drawer' } : { col: col, band: 'full' };
    }
    if (fp.band === 'back') {
      if (!occ.back) return { reason: 'Too deep for this drawer' };
      var cb = freeSpan(occ.back, fp.wcols);
      return cb < 0 ? { reason: 'No space left in this drawer' } : { col: cb, band: 'back' };
    }
    // front-depth trays fit in either band; prefer the front strip
    var order = occ.front ? ['front', 'back'] : ['back'];
    for (var i = 0; i < order.length; i++) {
      var k = order[i];
      if (!occ[k]) continue;
      var c2 = freeSpan(occ[k], fp.wcols);
      if (c2 >= 0) return { col: c2, band: k };
    }
    return { reason: 'No space left in this drawer' };
  }

  /* Place a set at explicit (band,col) ONLY if that band exists in the drawer,
     the span fits the columns, and every target cell is free. Returns true on
     success. Used by loadKit to honour kit coordinates without ever overlapping
     or landing in a non-existent band. */
  function placeAtIfFree(drawer, set, band, col, wcols) {
    if (!wcols || col < 0 || col + wcols > drawer.cols) return false;
    var occ = occupancy(drawer);
    var keys = band === 'full' ? drawer.bands.map(function (b) { return b.key; }) : [band];
    for (var ki = 0; ki < keys.length; ki++) {
      var cells = occ[keys[ki]];
      if (!cells) return false; /* band absent in this drawer */
      for (var c = col; c < col + wcols; c++) { if (cells[c]) return false; }
    }
    drawer.placements.push({ uid: S.uid++, itemId: set.itemId, band: band, col: col, wcols: wcols });
    return true;
  }
  function placeSet(drawer, set) {
    var slot = findSlot(drawer, set);
    if (slot.reason) return slot;
    drawer.placements.push({
      uid: S.uid++, itemId: set.itemId, band: slot.band, col: slot.col,
      wcols: footprint(set).wcols
    });
    return slot;
  }

  /* ---------- persistence (localStorage + shareable URL hash) ---------- */
  function buildPayload() {
    return S.storage ? {
      storageId: S.storage.itemId,
      placements: S.drawers.map(function (d) {
        return d.placements.map(function (p) { return { itemId: p.itemId, band: p.band, col: p.col, wcols: p.wcols }; });
      })
    } : null;
  }
  function encodeBuild(payload) {
    /* compact: storageId|drawer,drawer,… where drawer = item:band:col:wcols;… */
    var b = { back: 'b', front: 'f', full: 'x' };
    return payload.storageId + '|' + payload.placements.map(function (list) {
      return list.map(function (p) { return p.itemId + ':' + (b[p.band] || 'b') + ':' + p.col + ':' + p.wcols; }).join(';');
    }).join(',');
  }
  function decodeBuild(str) {
    var b = { b: 'back', f: 'front', x: 'full' };
    var parts = String(str).split('|');
    if (parts.length !== 2 || !parts[0]) return null;
    return {
      storageId: parts[0],
      placements: parts[1].split(',').map(function (row) {
        return row ? row.split(';').map(function (t) {
          var f = t.split(':');
          return { itemId: f[0], band: b[f[1]] || 'back', col: parseInt(f[2], 10) || 0, wcols: parseInt(f[3], 10) || 1 };
        }) : [];
      })
    };
  }
  function saveBuild() {
    var payload = buildPayload();
    try {
      payload ? localStorage.setItem('cf-build-v1', JSON.stringify(payload)) : localStorage.removeItem('cf-build-v1');
    } catch (e) { /* private mode */ }
    try {
      var url = location.pathname + location.search + (payload ? '#b=' + encodeURIComponent(encodeBuild(payload)) : '');
      history.replaceState(null, '', url);
    } catch (e) { /* sandboxed */ }
  }
  function applyPayload(b) {
      var storage = S.storageMap[b.storageId];
      if (!storage) return;
      selectStorage(storage, true);
      (b.placements || []).forEach(function (list, i) {
        if (!S.drawers[i]) return;
        list.forEach(function (p) {
          if (S.setMap[p.itemId]) S.drawers[i].placements.push({ uid: S.uid++, itemId: p.itemId, band: p.band, col: p.col, wcols: p.wcols });
        });
      });
  }
  function restoreBuild() {
    try {
      var mm = location.hash.match(/[#&]m=([^&]+)/);
      if (mm) {
        var listSkus = decodeURIComponent(mm[1]).split(/[,;\s]+/);
        organizeMatchedList(listSkus);
        if (S.storage) return;
      }
      var m = location.hash.match(/#b=([^&]+)/);
      if (m) {
        var fromUrl = decodeBuild(decodeURIComponent(m[1]));
        if (fromUrl && S.storageMap[fromUrl.storageId]) { applyPayload(fromUrl); saveBuild(); return; }
      }
      var raw = localStorage.getItem('cf-build-v1');
      if (raw) applyPayload(JSON.parse(raw));
    } catch (e) { /* ignore */ }
  }

  /* ---------- actions ---------- */
  function selectStorage(storage, quiet) {
    S.storage = storage;
    S.drawers = buildDrawers(storage);
    S.openPicker = null; S.status = '';
    if (!quiet) saveBuild();
  }
  function clearStorage() {
    S.storage = null; S.drawers = []; S.openPicker = null;
    saveBuild();
  }
  function loadKit(kit) {
    var storage = S.storageMap[kit.toolstorageId];
    if (!storage) return;
    selectStorage(storage, true);
    var skipped = 0;
    (kit.drawers || []).forEach(function (kd) {
      var drawer = S.drawers[(kd.drawerIndex || 1) - 1];
      if (!drawer) return;
      (kd.sets || []).forEach(function (ps) {
        var set = S.setMap[ps.itemId];
        if (!set) return;
        if (!availOf(ps.itemId)) { skipped++; return; }
        /* Prefer the kit's own coordinates, but ONLY when they are valid for
           THIS drawer: the band must exist in the drawer, the columns must fit,
           and the cells must be free. Otherwise fall back to placeSet — the
           same validated slot-finder the scratch path uses. The kit feed can
           carry a tray band (e.g. shallow 'front') that a single-band drawer
           doesn't have, which previously overlapped trays and read 0% space. */
        var fp = footprint(set);
        var col = Math.max(0, Math.round(num(ps.x) / COL_MM));
        var wcols = fp ? fp.wcols : Math.max(1, Math.round(num(ps.width) / COL_MM));
        var band = fp ? fp.band : (num(ps.depth) >= 379 ? 'full' : num(ps.depth) >= 264 ? 'back' : 'front');
        if (placeAtIfFree(drawer, set, band, col, wcols)) return;
        if (placeSet(drawer, set).reason) { skipped++; }
      });
    });
    saveBuild();
    S.kitNote = skipped ? skipped + ' tray' + (skipped === 1 ? '' : 's') + ' in this kit ' + (skipped === 1 ? 'is' : 'are') + ' sold out and ' + (skipped === 1 ? 'was' : 'were') + ' left out.' : '';
  }

  function applyTradeBuild(slug, key) {
    var tr = S.trades.filter(function (t) { return t.slug === slug; })[0];
    if (!tr) return;
    var b0 = tr.builds.filter(function (x) { return x.key === key; })[0] || tr.builds[0];
    var b = (b0.variants && b0.variants[S.tradeMaterial]) || b0;
    var storage = S.storageMap[b.storageId];
    if (!storage) return;
    selectStorage(storage, true);
    var skipped = 0;
    b.sets.forEach(function (id) {
      var set = S.setMap[id];
      if (!set || !availOf(id)) { skipped++; return; }
      var placed = false;
      for (var i = 0; i < S.drawers.length && !placed; i++) {
        placed = !placeSet(S.drawers[i], set).reason;
      }
      if (!placed) skipped++;
    });
    var matLabel = S.tradeMaterial === 'tt' ? ' in plastic trays' : S.tradeMaterial === 'foam' ? ' in foam trays' : '';
    S.kitNote = 'Built for ' + tr.name + ' work' + matLabel + ' — every tray is adjustable.' +
      (skipped ? ' (' + skipped + ' tray' + (skipped === 1 ? '' : 's') + ' currently unavailable ' + (skipped === 1 ? 'was' : 'were') + ' left out.)' : '');
    S.trade = null;
    saveBuild();
  }

  /* Matcher handoff: #m=SKU,SKU,… (competitor list already matched to Teng
     component SKUs). Reverse-BOM: find the fewest trays that hold the most of
     the list, place them into a cabinet, report coverage. */
  function organizeMatchedList(skus) {
    var wanted = {};
    skus.forEach(function (k) { k = String(k).trim().toUpperCase(); if (k) wanted[k] = true; });
    var wantedCount = Object.keys(wanted).length;
    if (!wantedCount) return;
    var trayHits = S.sets.map(function (set) {
      if (!availOf(set.itemId)) return null;
      var hits = (set.includes || []).filter(function (c) { return wanted[String(c).trim().toUpperCase()]; });
      return hits.length ? { set: set, hits: hits } : null;
    }).filter(Boolean);
    var covered = {}, chosen = [];
    for (;;) {
      trayHits.sort(function (a, b) {
        var na = a.hits.filter(function (h) { return !covered[h.toUpperCase()]; }).length;
        var nb = b.hits.filter(function (h) { return !covered[h.toUpperCase()]; }).length;
        return nb - na || num(a.set.itemWeight) - num(b.set.itemWeight);
      });
      var top = trayHits[0];
      if (!top) break;
      var fresh = top.hits.filter(function (h) { return !covered[h.toUpperCase()]; });
      if (!fresh.length) break;
      chosen.push(top.set);
      fresh.forEach(function (h) { covered[h.toUpperCase()] = true; });
      trayHits.shift();
    }
    if (!chosen.length) { S.kitNote = 'We could not match your list to any trays in stock — build from scratch below.'; return; }
    // cabinet: smallest available roller that takes every tray; else the biggest.
    var cabs = S.storages.filter(function (st) {
      return availOf(st.itemId) && String(st.ItemTypeOfStorage || st.productType || '').toLowerCase().indexOf('roller') >= 0;
    }).sort(function (a, b) { return (parseInt(a.numberOfDrawerInStorage, 10) || 0) - (parseInt(b.numberOfDrawerInStorage, 10) || 0); });
    if (!cabs.length) return;
    var placedBest = -1;
    for (var ci = 0; ci < cabs.length; ci++) {
      selectStorage(cabs[ci], true);
      var placed = 0;
      chosen.forEach(function (set) {
        for (var i = 0; i < S.drawers.length; i++) {
          if (!placeSet(S.drawers[i], set).reason) { placed++; return; }
        }
      });
      placedBest = placed;
      if (placed === chosen.length) break; // smallest cabinet that fits all
    }
    var nCov = Object.keys(covered).length;
    S.kitNote = 'Your list, organized: ' + nCov + ' of ' + wantedCount + ' tools covered across ' +
      placedBest + ' tray' + (placedBest === 1 ? '' : 's') +
      (nCov < wantedCount ? ' — the rest are sold separately or unavailable.' : '.') + ' Every tray is adjustable.';
    saveBuild();
  }

  /* ── tray quick view: expands in place, X to close, never leaves the page ── */
  var trayContents = null;
  function fetchTrayContents() {
    if (trayContents) return Promise.resolve(trayContents);
    var url = (window.APP_CONFIG || {}).trayContentsUrl;
    if (!url) return Promise.resolve({});
    return fetchJson(url, 'contents').then(function (d) { trayContents = d; return d; })
      .catch(function () { trayContents = {}; return trayContents; });
  }
  function openQuickView(itemId) {
    var set = S.setMap[itemId];
    if (!set) return;
    closeQuickView();
    var wrap = document.createElement('div');
    wrap.id = 'cf-qv';
    wrap.innerHTML = '<div class="cf-qv__backdrop" data-cf="qv-close"></div>' +
      '<div class="cf-qv__card" role="dialog" aria-modal="true" aria-label="' + esc(set.description) + '">' +
      '<button type="button" class="cf-qv__x" data-cf="qv-close" aria-label="Close">×</button>' +
      '<div class="cf-qv__media">' + imgTag(itemId, set.itemImageUrl, 700, set.description) + '</div>' +
      '<div class="cf-qv__body">' +
      '<h3>' + esc(set.description) + '</h3>' +
      '<p class="cf-dim">' + esc(set.itemId) + ' · ' + esc(set.typeOfSet || '') +
      (set.setNumberOfPieces ? ' · ' + esc(String(set.setNumberOfPieces)) + ' pieces' : '') +
      ' · <strong>' + money(priceOf(itemId)) + '</strong></p>' +
      (etaOf(itemId) ? '<p class="cf-backorder">Backorder · estimated ' + esc(fmtEta(etaOf(itemId))) + '</p>' : '') +
      '<div class="cf-qv__contents"><p class="cf-dim">Loading contents…</p></div>' +
      '</div></div>';
    document.body.appendChild(wrap);
    document.addEventListener('keydown', qvEsc);
    fetchTrayContents().then(function (d) {
      var box = wrap.querySelector('.cf-qv__contents');
      if (!box) return;
      var lines = d[itemId];
      if (lines && lines.length) {
        box.innerHTML = '<h4>What\'s in this tray</h4>' +
          '<p class="cf-dim cf-qv__refill">Lost or worn one? Buy just that piece:</p>' +
          '<ul class="cf-qv__list">' +
          lines.map(function (l) {
            if (typeof l === 'string') return '<li>' + esc(l) + '</li>';
            return '<li class="cf-qv__row"><span>' + esc(l.t) + '</span>' +
              '<span class="cf-qv__rowend">' + money(num(l.p)) +
              (l.a ? ' <button type="button" class="cf-btn cf-qv__add" data-cf="add-component" data-id="' + l.v + '">Add</button>'
                   : ' <span class="cf-oos">Sold out</span>') +
              '</span></li>';
          }).join('') + '</ul>';
      } else if (set.bulletText) {
        box.innerHTML = '<h4>About this tray</h4><ul>' +
          String(set.bulletText).split(';').map(function (l) { return '<li>' + esc(l.trim()) + '</li>'; }).join('') + '</ul>';
      } else {
        box.innerHTML = '';
      }
    });
  }
  function addComponent(variantId, btn) {
    btn.disabled = true;
    var was = btn.textContent;
    btn.textContent = '…';
    /* Single-piece refills (data-cf="add-component" in the tray quick view)
       are attributable to a build but NEVER tier-qualifying — a lost-part
       reorder is not a new box (decided, R1 contract). */
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1, properties: { _kit_build_component: '1' } }] })
    }).then(function (res) {
      if (res.ok) { btn.textContent = 'Added ✓'; setTimeout(function () { btn.textContent = was; btn.disabled = false; }, 1800); return; }
      return res.json().catch(function () { return {}; }).then(function (err) {
        btn.textContent = was; btn.disabled = false;
        btn.title = err.description || 'Could not add';
      });
    }).catch(function () { btn.textContent = was; btn.disabled = false; });
  }
  function qvEsc(e) { if (e.key === 'Escape') closeQuickView(); }
  function closeQuickView() {
    var el = document.getElementById('cf-qv');
    if (el) el.remove();
    document.removeEventListener('keydown', qvEsc);
  }

  /* ── Complete my kit: gap-check the CURRENT build against a trade ── */
  var GROUP_LABEL = { sockets: 'sockets', impact_sockets: 'impact sockets', spanners: 'wrenches', hex_keys: 'hex keys', torx: 'Torx' };
  function fetchGapData() {
    if (S.gapData) return Promise.resolve(S.gapData);
    var url = (window.APP_CONFIG || {}).tradeCheckpointsUrl;
    if (!url) return Promise.resolve(null);
    return fetchJson(url, 'checkpoints').then(function (d) { S.gapData = d; return d; })
      .catch(function () { return null; });
  }
  function placedTrayIds() {
    var ids = [];
    S.drawers.forEach(function (d) { d.placements.forEach(function (p) { ids.push(p.itemId); }); });
    return ids;
  }
  function gapReport(slug) {
    var P = S.gapData && S.gapData.personas[slug];
    if (!P) return null;
    var covered = {};
    placedTrayIds().forEach(function (id) {
      (P.cov[id] || []).forEach(function (i) { covered[i] = true; });
    });
    var missing = [];
    P.cps.forEach(function (cp, i) { if (!covered[i]) missing.push({ i: i, group: cp[0], drive: cp[1], mm: cp[2] }); });
    // summarize missing by group+drive as mm ranges
    var byKey = {};
    missing.forEach(function (m) {
      var k = m.group + '|' + (m.drive || '');
      (byKey[k] = byKey[k] || []).push(m.mm);
    });
    var lines = Object.keys(byKey).map(function (k) {
      var parts = k.split('|');
      var mms = byKey[k].sort(function (a, b) { return a - b; });
      var span = mms.length === 1 ? mms[0] + 'mm' : mms[0] + '–' + mms[mms.length - 1] + 'mm';
      var imp = P.imp[parts[0]] || '';
      return { label: (parts[1] ? parts[1] + ' ' : '') + (GROUP_LABEL[parts[0]] || parts[0]) + ': ' + span,
               n: mms.length, imp: imp };
    }).sort(function (a, b) { return (a.imp === 'essential' ? 0 : 1) - (b.imp === 'essential' ? 0 : 1) || b.n - a.n; });
    // suggestions: trays adding the most missing checkpoints
    var missSet = {};
    missing.forEach(function (m) { missSet[m.i] = true; });
    var placed = {};
    placedTrayIds().forEach(function (id) { placed[id] = true; });
    var sugg = [];
    Object.keys(P.cov).forEach(function (id) {
      if (placed[id] || !availOf(id)) return;
      var gain = P.cov[id].filter(function (i) { return missSet[i]; }).length;
      if (gain > 0) sugg.push({ id: id, gain: gain });
    });
    sugg.sort(function (a, b) { return b.gain - a.gain || priceOf(a.id) - priceOf(b.id); });
    return { total: P.cps.length, covered: P.cps.length - missing.length, lines: lines.slice(0, 6), sugg: sugg.slice(0, 3), name: P.name };
  }

  function cartItems() {
    var counts = {};
    if (S.storage) counts[S.storage.itemId] = 1;
    S.drawers.forEach(function (d) {
      d.placements.forEach(function (p) { counts[p.itemId] = (counts[p.itemId] || 0) + 1; });
    });
    var items = [], units = 0, total = 0, excluded = [], latestEta = null;
    Object.keys(counts).forEach(function (id) {
      var e = S.sku[id];
      if (!e) return;
      if (e.avail === false) { excluded.push(id); return; }
      var qty = counts[id] * (S.bays || 1);
      var item = { id: e.variantId, quantity: qty };
      var props = {};
      if (e.eta) props.ETA = fmtEta(e.eta) + ', ' + e.eta.slice(0, 4) + ' (estimated)';
      if (S.bays > 1) props.Fleet = S.bays + ' identical bays';
      /* Every line carries the build id — kickback attribution joins the
         Shopify order back to this build regardless of which trays it holds. */
      item.properties = Object.assign({}, props, { _kit_build: BUILD_ID });
      items.push(item);
      units += qty; total += num(e.price) * qty;
      if (e.eta && (!latestEta || e.eta > latestEta)) latestEta = e.eta;
    });
    return { items: items, units: units, total: total, excluded: excluded, latestEta: latestEta };
  }

  function addToCart(attempt) {
    attempt = attempt || 0;
    var c = cartItems();
    if (!c.items.length) { setStatus('Everything in this build is currently sold out.'); return; }
    var btn = document.getElementById('cf-cart-add');
    btn.disabled = true;
    setStatus('Adding to cart…');
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: c.items })
    }).then(function (res) {
      if (res.ok) {
        /* Stamp the cart-level attribute too — belt-and-braces alongside the
           per-line _kit_build property above. Best-effort: wallet checkouts
           (Shop Pay / shop.app) may drop cart attributes, and line properties
           are the primary attribution carrier, so a failure here never blocks
           the redirect. */
        fetch('/cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { kit_builder: BUILD_ID } })
        }).catch(function () { /* silent — properties already carry attribution */ })
          .then(function () { window.location.href = '/cart'; });
        return;
      }
      return res.json().catch(function () { return {}; }).then(function (err) {
        var msg = err.description || err.message || '';
        /* Stale availability: Shopify names the offending product — mark it
           unavailable locally and retry with the rest. */
        var m = msg.match(/'([^']+)'/);
        if (m && attempt < 4) {
          var hit = null;
          Object.keys(S.sku).forEach(function (id) { if (S.sku[id].title === m[1]) hit = id; });
          if (hit) { S.sku[hit].avail = false; render(); addToCart(attempt + 1); return; }
        }
        throw new Error(msg || ('Could not add to cart (' + res.status + ')'));
      });
    }).catch(function (e) {
      setStatus(e.message); btn.disabled = false;
    });
  }
  function setStatus(msg) {
    var el = document.getElementById('cf-cart-status');
    if (el) el.textContent = msg;
  }

  /* ---------- picker filtering ---------- */
  var SIZE_ORDER = ['TT1', 'TT2', 'TT3', 'TT4', 'TTX2', 'TTX4', 'FOAM1', 'FOAM2', 'FOAM3', 'FOAM4X4', 'FOAM6X6', 'FOAMX2', 'FOAMX4'];
  function sizesFor(material) {
    var seen = {};
    S.sets.forEach(function (set) {
      var t = String(set.typeOfSet || '');
      if (!t) return;
      if (material === 'foam' && t.indexOf('FOAM') !== 0) return;
      if (material === 'tt' && t.indexOf('FOAM') === 0) return;
      seen[t] = true;
    });
    return SIZE_ORDER.filter(function (t) { return seen[t]; });
  }
  function setTypeLabel(set) {
    var t = String(set.typeOfSet || '');
    return t.indexOf('FOAM') === 0 ? 'Foam' : 'TT';
  }
  function footprintLabel(drawer, set) {
    var fp = footprint(set);
    if (!fp) return '';
    var colTxt = fp.wcols === drawer.cols ? 'full width' : fp.wcols + ' of ' + drawer.cols + ' columns';
    if (fp.band === 'full') return colTxt + ' · full depth';
    return colTxt + ' · ' + (fp.band === 'back' ? 'deep row' : 'shallow row');
  }
  function pickerSets(drawer) {
    var q = S.pickerText.trim().toLowerCase();
    var out = [];
    S.sets.forEach(function (set) {
      if (S.pickerType !== 'all' && setTypeLabel(set).toLowerCase() !== S.pickerType) return;
      if (S.pickerCat !== 'all' && set.cat !== S.pickerCat) return;
      if (S.pickerSize !== 'all' && String(set.typeOfSet || '') !== S.pickerSize) return;
      if (q && (set.description + ' ' + set.itemId).toLowerCase().indexOf(q) < 0) return;
      if (!availOf(set.itemId)) { out.push({ set: set, fits: false, reason: 'Sold out' }); return; }
      var slot = findSlot(drawer, set);
      out.push({ set: set, fits: !slot.reason, reason: slot.reason || '' });
    });
    out.sort(function (a, b) {
      if (a.fits !== b.fits) return a.fits ? -1 : 1;
      return (a.set.typeOfSet || '').localeCompare(b.set.typeOfSet || '') ||
             (a.set.description || '').localeCompare(b.set.description || '');
    });
    return out;
  }

  /* ---------- rendering ---------- */
  function storageTypeKey(st) {
    var v = String(st.ItemTypeOfStorage || st.productType || '').toLowerCase();
    if (v.indexOf('roller') >= 0) return 'roller';
    if (v.indexOf('chest') >= 0) return 'chest';
    return 'other';
  }

  function renderStoragePicker() {
    var q = S.catText.trim().toLowerCase();
    var list = S.storages.filter(function (st) {
      if (S.catType !== 'all' && storageTypeKey(st) !== S.catType) return false;
      if (q && (st.description + ' ' + st.itemId).toLowerCase().indexOf(q) < 0) return false;
      return true;
    });
    var kitCards = S.kits.map(function (k) {
      var st = S.storageMap[k.toolstorageId];
      var im = img(st && st.itemImageUrl);
      var pieces = (k.description.match(/(\d+)\s*pieces/i) || [])[1];
      return '<button type="button" class="cf-kit" data-cf="kit" data-id="' + esc(k.itemId) + '">' +
        (im ? '<img src="' + esc(im) + '" alt="" loading="lazy">' : '<span class="cf-kit__ph"></span>') +
        '<span class="cf-kit__body"><strong>' + esc(k.itemId) + '</strong>' +
        '<span>' + esc(pieces ? pieces + ' pieces, pre-configured' : 'Pre-configured kit') + '</span></span></button>';
    }).join('');
    var chips = [['all', 'All'], ['roller', 'Roller cabinets'], ['chest', 'Tool chests'], ['other', 'Other']]
      .map(function (c) {
        return '<button type="button" class="cf-chip' + (S.catType === c[0] ? ' is-on' : '') + '" data-cf="cat-type" data-id="' + c[0] + '">' + c[1] + '</button>';
      }).join('');
    var cards = list.map(function (st) {
      var n = parseInt(st.numberOfDrawerInStorage, 10) || 0;
      var ok = availOf(st.itemId);
      var media = imgTag(st.itemId, st.itemImageUrl, 480, st.description);
      return '<article class="cf-card' + (ok ? '' : ' is-oos') + '">' +
        '<button type="button" class="cf-card__media" data-cf="pick-storage" data-id="' + esc(st.itemId) + '"' + (ok ? '' : ' disabled') + '>' +
        (media || '<span class="cf-card__ph">' + esc(st.itemId) + '</span>') +
        '</button>' +
        '<div class="cf-card__body">' +
        '<h3>' + esc(st.description) + '</h3>' +
        '<p class="cf-dim">' + esc(st.itemId) + ' · ' + n + ' drawer' + (n === 1 ? '' : 's') + '</p>' +
        (ok && etaOf(st.itemId) ? '<p class="cf-backorder">Backorder · estimated ' + esc(fmtEta(etaOf(st.itemId))) + '</p>' : '') +
        '<div class="cf-card__foot"><strong>' + money(priceOf(st.itemId)) + '</strong>' +
        (ok ? '<button type="button" class="cf-btn cf-btn--red" data-cf="pick-storage" data-id="' + esc(st.itemId) + '">Select</button>'
            : '<span class="cf-oos">Sold out</span>') + '</div>' +
        '</div></article>';
    }).join('');
    var tradeChips = S.trades.map(function (t) {
      return '<button type="button" class="cf-trade' + (S.trade === t.slug ? ' is-on' : '') + '" data-cf="trade" data-id="' + esc(t.slug) + '">' +
        '<span class="cf-trade__ico">' + (TRADE_ICONS[t.slug] || '🧰') + '</span>' + esc(t.name) + '</button>';
    }).join('');
    var tradePanel = '';
    if (S.trade) {
      var tr = S.trades.filter(function (t) { return t.slug === S.trade; })[0];
      if (tr) {
        var matChips = [['mix', 'Best mix'], ['tt', 'Plastic trays'], ['foam', 'Foam trays']].map(function (m) {
          return '<button type="button" class="cf-chip' + (S.tradeMaterial === m[0] ? ' is-on' : '') + '" data-cf="trade-material" data-id="' + m[0] + '">' + m[1] + '</button>';
        }).join('');
        var opts = tr.builds.map(function (b) {
          var v = (b.variants && b.variants[S.tradeMaterial]) || b;
          var total = 0, n = 0;
          if (S.sku[v.storageId]) total += num(S.sku[v.storageId].price);
          v.sets.forEach(function (id) { if (S.sku[id]) { total += num(S.sku[id].price); n++; } });
          return '<article class="cf-pick"><div class="cf-pick__body">' +
            '<h4>' + esc(b.label) + '</h4>' +
            '<p class="cf-dim">' + esc(String(S.storageMap[v.storageId] ? S.storageMap[v.storageId].description : v.storageId)) + ' + ' + n + ' trays</p>' +
            '<div class="cf-pick__foot"><strong>' + money(total) + '</strong>' +
            '<button type="button" class="cf-btn cf-btn--red" data-cf="load-trade" data-id="' + esc(tr.slug) + '" data-build="' + esc(b.key) + '">Load this build</button></div>' +
            '</div></article>';
        }).join('');
        tradePanel = '<div class="cf-tradepanel"><p class="cf-dim">' + esc(tr.description || '') + ' Loads a complete, drawer-by-drawer build — every tray adjustable.</p>' +
          '<div class="cf-chiprow" style="margin-bottom:0.75rem">' + matChips + '</div>' +
          '<div class="cf-grid cf-grid--picker">' + opts + '</div></div>';
      }
    }
    /* Path chooser: open with a question, one decision at a time. The three
       cards ARE the interface — nothing below renders until one is tapped,
       then the cards compress into tabs so switching stays one tap away. */
    /* Blueprint chooser (direction C, approved 2026-07-17): monospace spec
       line + product imagery per path. The kit tag reads LIVE availability —
       it only claims stock when at least one pre-configured kit is buyable. */
    var kitAvail = S.kits && S.kits.some(function (k) { return availOf(k.itemId); });
    var PATHS = [
      { key: 'kit', meta: 'PATH-01 \u00b7 KIT', tag: kitAvail ? 'IN STOCK \u00b7 FT WORTH' : 'SHIPS FROM FT WORTH',
        t: 'Start from a pre-configured kit',
        d: kitAvail ? 'Factory-built boxes, ready to load \u2014 ships immediately.' : 'Factory-built boxes, ready to load.',
        img: 'https://cdn.shopify.com/s/files/1/2552/8394/files/916341.png?v=1743071188' },
      { key: 'trade', meta: 'PATH-02 \u00b7 TRADE', tag: 'GUIDED',
        t: 'Build it for me', d: 'Tell us your trade. We fill the drawers.',
        img: 'https://cdn.shopify.com/s/files/1/1019/9793/6983/files/145869_9502bc96-a483-4013-9d5d-62ea41375392.jpg?v=1783168713' },
      { key: 'scratch', meta: 'PATH-03 \u00b7 CUSTOM', tag: 'FULL CONTROL',
        t: 'Build from scratch', d: 'Pick a cabinet. Fill every drawer yourself.',
        img: 'https://cdn.shopify.com/s/files/1/1019/9793/6983/files/145049_ad4db1ec-c191-4659-ab60-72c1e5ed4788.jpg?v=1783168711' }
    ];
    var pathCards = PATHS.map(function (p) {
      return '<button type="button" class="cf-path' + (S.path === p.key ? ' is-on' : '') + '" data-cf="path" data-id="' + p.key + '">' +
        '<span class="cf-path__meta"><span>' + p.meta + '</span><em>' + p.tag + '</em></span>' +
        '<span class="cf-path__img" style="background-image:url(\'' + p.img + '\')" aria-hidden="true"></span>' +
        '<span class="cf-path__t">' + p.t + '</span>' +
        '<span class="cf-path__d">' + p.d + '</span>' +
        '<span class="cf-path__go" aria-hidden="true">' + (S.path === p.key ? 'SELECTED &#10003; &middot; SHOW ALL' : 'SELECT &#8594;') + '</span></button>';
    }).join('');
    var body = '';
    if (S.path === 'trade' && tradeChips) {
      body = '<div class="cf-kits"><p class="cf-kits__label"><strong>What do you do?</strong> Pick your trade — you\'ll get complete configurations built from the tools that trade actually uses, every tray adjustable:</p><div class="cf-trades">' + tradeChips + '</div>' + tradePanel + '</div>';
    } else if (S.path === 'kit' && kitCards) {
      body = '<div class="cf-kits"><p class="cf-kits__label"><strong>Pre-configured kits</strong> straight from the Teng Tools range \u2014 in stock in Fort Worth, ready to ship. Load one, then add, swap or remove any tray:</p><div class="cf-kits__row">' + kitCards + '</div></div>';
    } else if (S.path === 'scratch') {
      body = '<p class="cf-kits__label"><strong>Pick your storage.</strong> Then fill each drawer tray by tray — the builder shows your real drawers to scale and only offers trays that fit:</p>' +
        '<p class="cf-scratch-hint">Don\'t want to start empty? <button type="button" class="cf-link cf-link--inline" data-cf="path" data-id="kit">Start from a pre-configured kit</button> and change anything you like.</p>' +
        '<div class="cf-toolbar"><input type="search" class="cf-search" aria-label="Search cabinets and chests" placeholder="Search cabinets and chests…" value="' + esc(S.catText) + '" data-cf="cat-search">' +
        '<div class="cf-chiprow">' + chips + '</div></div>' +
        (cards ? '<div class="cf-grid">' + cards + '</div>' : '<p class="cf-empty">Nothing matches that search.</p>');
    }
    return '<div class="cf-step"><span class="cf-step__n">1</span><h2>How do you want to build your box?</h2></div>' +
      '<div class="cf-paths' + (S.path ? ' is-picked' : '') + '">' + pathCards + '</div>' + body;
  }

  function bandRows(drawer) {
    if (drawer.bands.length === 2) return '264fr 115fr';
    return '1fr';
  }

  function renderDrawer(drawer) {
    var occ = occupancy(drawer);
    var totalCells = 0, usedCells = 0;
    drawer.bands.forEach(function (b) {
      totalCells += drawer.cols;
      occ[b.key].forEach(function (v) { if (v) usedCells++; });
    });
    var fillPct = totalCells ? Math.round(usedCells / totalCells * 100) : 0;
    var wKg = drawerWeightG(drawer) / 1000;
    var wPct = drawer.capKg ? Math.min(100, Math.round(wKg / drawer.capKg * 100)) : 0;

    var blocks = drawer.placements.map(function (p) {
      var set = S.setMap[p.itemId] || {};
      var row = p.band === 'full' ? '1 / -1' : (p.band === 'back' || drawer.bands.length === 1 ? '1' : '2');
      /* The corporate tray assets are shot top-down in the tray's real drawer
         orientation (portrait trays photograph portrait) — render as-is. */
      var asset = img(set.itemImageUrl);
      return '<div class="cf-tray" style="grid-column:' + (p.col + 1) + ' / span ' + p.wcols + ';grid-row:' + row + ';">' +
        (asset ? '<img src="' + esc(asset) + '" alt="' + esc(set.description || '') + '" loading="lazy">' : '') +
        '<button type="button" class="cf-tray__x" data-cf="remove" data-drawer="' + drawer.index + '" data-uid="' + p.uid + '" aria-label="Remove ' + esc(set.itemId) + '">×</button>' +
        '<span class="cf-tray__tag">' + esc(set.itemId) + '</span></div>';
    }).join('');

    var pickerHtml = S.openPicker === drawer.index ? renderPicker(drawer) : '';
    var chipList = drawer.placements.length
      ? '<ul class="cf-traylist">' + drawer.placements.map(function (p) {
          var set = S.setMap[p.itemId] || {};
          return '<li><button type="button" class="cf-qv-open cf-qv-open--text" data-cf="quick-view" data-id="' + esc(p.itemId) + '">' + esc(set.description || p.itemId) + '</button>' +
            ' <span class="cf-dim">' + esc(p.itemId) + ' · ' + money(priceOf(p.itemId)) + '</span>' +
            ' <button type="button" class="cf-traylist__x" data-cf="remove" data-drawer="' + drawer.index + '" data-uid="' + p.uid + '" aria-label="Remove">×</button></li>';
        }).join('') + '</ul>'
      : '';

    return '<section class="cf-drawer" data-drawer-index="' + drawer.index + '">' +
      '<header class="cf-drawer__head">' +
      '<div><h3>' + esc(drawer.name) + '</h3>' +
      '<p class="cf-dim">' + drawer.w + ' × ' + drawer.d + ' mm · ' + drawer.h + ' mm deep' +
      (drawer.capKg ? ' · up to ' + drawer.capKg + ' kg' : '') + '</p></div>' +
      '<div class="cf-meters"><div class="cf-meter"><span>Space</span><div class="cf-meter__bar"><i style="width:' + fillPct + '%"></i></div><span>' + fillPct + '%</span></div>' +
      (drawer.capKg ? '<div class="cf-meter"><span>Weight</span><div class="cf-meter__bar' + (wPct >= 100 ? ' is-max' : '') + '"><i style="width:' + wPct + '%"></i></div><span>' + wKg.toFixed(1) + ' kg</span></div>' : '') +
      '</div></header>' +
      '<div class="cf-canvas" style="aspect-ratio:' + drawer.w + '/' + drawer.d + ';grid-template-columns:repeat(' + drawer.cols + ',1fr);grid-template-rows:' + bandRows(drawer) + ';">' +
      blocks +
      (drawer.placements.length ? '' : '<div class="cf-canvas__hint">Empty — ' + drawer.cols + ' columns of 142 mm ready to fill</div>') +
      '</div>' + chipList +
      '<div class="cf-drawer__actions"><button type="button" class="cf-btn' + (S.openPicker === drawer.index ? '' : ' cf-btn--red') + '" data-cf="toggle-picker" data-id="' + drawer.index + '">' +
      (S.openPicker === drawer.index ? 'Close tray picker' : '+ Add trays to this drawer') + '</button></div>' +
      pickerHtml +
      '</section>';
  }

  function renderPicker(drawer) {
    var rows = pickerSets(drawer);
    var fitCount = rows.filter(function (r) { return r.fits; }).length;
    var shown = S.pickerShowAll ? rows : rows.filter(function (r) { return r.fits; });
    var chips = [['all', 'All trays'], ['foam', 'Foam trays'], ['tt', 'TT trays']].map(function (c) {
      return '<button type="button" class="cf-chip' + (S.pickerType === c[0] ? ' is-on' : '') + '" data-cf="picker-type" data-id="' + c[0] + '">' + c[1] + '</button>';
    }).join('');
    var sizeChips = [['all', 'All sizes']].concat(sizesFor(S.pickerType).map(function (t) { return [t, t]; }))
      .map(function (c) {
        return '<button type="button" class="cf-chip' + (S.pickerSize === c[0] ? ' is-on' : '') + '" data-cf="picker-size" data-id="' + c[0] + '">' + c[1] + '</button>';
      }).join('');
    var catChips = [['all', 'All tools']].concat(CATS.map(function (c) { return [c[0], c[1]]; }))
      .concat([['specialist', 'Specialist']])
      .map(function (c) {
        return '<button type="button" class="cf-chip' + (S.pickerCat === c[0] ? ' is-on' : '') + '" data-cf="picker-cat" data-id="' + c[0] + '">' + c[1] + '</button>';
      }).join('');
    var cards = shown.map(function (r) {
      var set = r.set;
      return '<article class="cf-pick' + (r.fits ? '' : ' is-no') + '">' +
        '<button type="button" class="cf-pick__media cf-qv-open" data-cf="quick-view" data-id="' + esc(set.itemId) + '">' + imgTag(set.itemId, set.itemImageUrl, 320, set.description) + '</button>' +
        '<div class="cf-pick__body"><h4><button type="button" class="cf-qv-open cf-qv-open--text" data-cf="quick-view" data-id="' + esc(set.itemId) + '">' + esc(set.description) + '</button></h4>' +
        '<p class="cf-dim">' + esc(set.itemId) + ' · ' + esc(footprintLabel(drawer, set)) + '</p>' +
        (r.fits && etaOf(set.itemId) ? '<p class="cf-backorder">Backorder · estimated ' + esc(fmtEta(etaOf(set.itemId))) + '</p>' : '') +
        (r.fits
          ? '<div class="cf-pick__foot"><strong>' + money(priceOf(set.itemId)) + '</strong>' +
            '<button type="button" class="cf-btn cf-btn--red" data-cf="add-set" data-drawer="' + drawer.index + '" data-id="' + esc(set.itemId) + '">Add</button></div>'
          : '<p class="cf-pick__no">' + esc(r.reason) + '</p>') +
        '</div></article>';
    }).join('');
    return '<div class="cf-picker">' +
      '<div class="cf-toolbar"><input type="search" class="cf-search" aria-label="Search trays" placeholder="Search trays…" value="' + esc(S.pickerText) + '" data-cf="picker-search">' +
      '<div class="cf-chiprow">' + chips + '</div></div>' +
      '<div class="cf-chiprow cf-chiprow--cats">' + sizeChips + '</div>' +
      '<div class="cf-chiprow cf-chiprow--cats">' + catChips + '</div>' +
      '<p class="cf-picker__count">' + fitCount + ' tray' + (fitCount === 1 ? '' : 's') + ' fit the space left in this drawer' +
      ' <button type="button" class="cf-link" data-cf="picker-showall">' + (S.pickerShowAll ? 'Show fitting only' : 'Show all') + '</button></p>' +
      (cards ? '<div class="cf-grid cf-grid--picker">' + cards + '</div>' : '<p class="cf-empty">No trays match.</p>') +
      '</div>';
  }

  function renderBuild() {
    var st = S.storage;
    var drawersHtml = S.drawers.map(renderDrawer).join('');
    return '<div class="cf-step"><span class="cf-step__n">2</span><h2>Fill your drawers</h2>' +
      '<button type="button" class="cf-backbtn" data-cf="change-storage">← Back to step 1</button></div>' +
      '<div class="cf-selected">' +
      '<div class="cf-selected__media">' + imgTag(st.itemId, st.itemImageUrl, 220, st.description) + '</div>' +
      '<div><p class="cf-kicker">' + esc(st.productType || 'Tool storage') + '</p>' +
      '<h3>' + esc(st.description) + '</h3>' +
      '<p class="cf-dim">' + esc(st.itemId) + ' · ' + money(priceOf(st.itemId)) + '</p></div>' +
      '</div>' + renderGapPanel() + drawersHtml;
  }

  function renderGapPanel() {
    var chips = S.trades.map(function (t) {
      return '<button type="button" class="cf-chip' + (S.gapTrade === t.slug ? ' is-on' : '') + '" data-cf="gap-trade" data-id="' + esc(t.slug) + '">' +
        (TRADE_ICONS[t.slug] || '') + ' ' + esc(t.name) + '</button>';
    }).join('');
    var body = '';
    if (S.gapTrade && S.gapData) {
      var r = gapReport(S.gapTrade);
      if (r) {
        var pct = r.total ? Math.round(r.covered / r.total * 100) : 0;
        body = '<div class="cf-gap__report">' +
          '<div class="cf-meter"><span>' + esc(r.name) + ' coverage</span><div class="cf-meter__bar"><i style="width:' + pct + '%"></i></div><span>' + r.covered + ' of ' + r.total + ' sizes</span></div>' +
          (r.lines.length
            ? '<p class="cf-gap__missing">Missing:</p><ul class="cf-gap__list">' +
              r.lines.map(function (l) { return '<li>' + esc(l.label) + (l.imp === 'essential' ? ' <em>essential</em>' : '') + '</li>'; }).join('') + '</ul>'
            : '<p class="cf-gap__done">Fully covered for this trade\'s size checklist. Nice box.</p>') +
          (r.sugg.length
            ? '<p class="cf-gap__missing">Close the gaps:</p>' + r.sugg.map(function (g) {
                var set = S.setMap[g.id] || {};
                return '<div class="cf-gap__sugg"><span>' + esc(set.description || g.id) +
                  ' <span class="cf-dim">+' + g.gain + ' sizes · ' + money(priceOf(g.id)) + '</span></span>' +
                  '<button type="button" class="cf-btn cf-btn--red" data-cf="gap-add" data-id="' + esc(g.id) + '">Add</button></div>';
              }).join('')
            : '') +
          '</div>';
      }
    } else if (S.gapTrade) {
      body = '<p class="cf-dim">Checking…</p>';
    }
    return '<section class="cf-gap"><h3>Complete my kit</h3>' +
      '<p class="cf-dim">Already own some of this? Pick your trade and see what your current build is missing.</p>' +
      '<div class="cf-chiprow">' + chips + '</div>' + body + '</section>';
  }

  function render() {
    root.innerHTML = '<div class="cf-app">' + (S.storage ? renderBuild() : renderStoragePicker()) + '</div>';
    renderBar();
  }

  var lastTotal = null;
  function syncBarMin() {
    bar.classList.toggle('is-min', !!S.barMin);
  }
  function renderBar() {
    var c = cartItems();
    bar.style.display = c.units > 0 ? '' : 'none';
    if (!c.units) { lastTotal = null; return; }
    syncBarMin();
    document.getElementById('cf-cart-count').textContent = c.units + (c.units === 1 ? ' item' : ' items');
    document.getElementById('cf-cart-total').textContent = money(c.total);
    document.getElementById('cf-pill-count').textContent = c.units + ' · ';
    document.getElementById('cf-pill-total').textContent = money(c.total);
    document.getElementById('cf-cart-add').disabled = !c.items.length;
    var notes = [];
    if (S.kitNote) { notes.push(S.kitNote); S.kitNote = ''; }
    if (c.excluded.length) notes.push(c.excluded.length + ' sold-out item' + (c.excluded.length === 1 ? '' : 's') + ' will not be added: ' + c.excluded.join(', '));
    if (c.latestEta) notes.push('Includes backorder items — complete kit estimated ' + fmtEta(c.latestEta) + '.');
    if (notes.length) setStatus(notes.join(' '));
    if (lastTotal !== null && lastTotal !== c.total) {
      bar.classList.remove('is-pulse');
      void bar.offsetWidth; /* restart the animation */
      bar.classList.add('is-pulse');
    }
    lastTotal = c.total;
  }

  /* ---------- events ---------- */
  function onClick(e) {
    var el = e.target.closest('[data-cf]');
    if (!el) return;
    var kind = el.getAttribute('data-cf');
    var id = el.getAttribute('data-id');
    if (kind === 'pick-storage') { selectStorage(S.storageMap[id]); render(); window.scrollTo({ top: root.offsetTop - 80, behavior: 'smooth' }); }
    else if (kind === 'change-storage') { clearStorage(); if (!S.path) S.path = 'scratch'; render(); }
    else if (kind === 'kit') { var k = S.kits.filter(function (x) { return x.itemId === id; })[0]; if (k) { loadKit(k); render(); } }
    else if (kind === 'cat-type') { S.catType = id; render(); }
    else if (kind === 'path') { S.path = (S.path === id ? null : id); render(); }
    else if (kind === 'trade') { S.trade = S.trade === id ? null : id; S.tradeMaterial = 'mix'; render(); }
    else if (kind === 'trade-material') { S.tradeMaterial = id; render(); }
    else if (kind === 'gap-trade') {
      S.gapTrade = S.gapTrade === id ? null : id;
      if (S.gapTrade && !S.gapData) { fetchGapData().then(function () { render(); }); }
      render();
    }
    else if (kind === 'gap-add') {
      var gset = S.setMap[id];
      if (gset) {
        var ok = false;
        for (var gi = 0; gi < S.drawers.length && !ok; gi++) ok = !placeSet(S.drawers[gi], gset).reason;
        if (!ok) setStatus('No drawer space left for that tray — remove something first.');
        saveBuild(); render();
      }
    }
    else if (kind === 'quick-view') { openQuickView(id); }
    else if (kind === 'qv-close') { closeQuickView(); }
    else if (kind === 'load-trade') { applyTradeBuild(id, el.getAttribute('data-build')); render(); window.scrollTo({ top: root.offsetTop - 80, behavior: 'smooth' }); }
    else if (kind === 'toggle-picker') {
      var idx = parseInt(id, 10);
      S.openPicker = S.openPicker === idx ? null : idx;
      S.pickerText = ''; S.pickerShowAll = false; S.pickerCat = 'all'; S.pickerSize = 'all';
      render();
    }
    else if (kind === 'picker-type') { S.pickerType = id; S.pickerSize = 'all'; render(); }
    else if (kind === 'picker-cat') { S.pickerCat = id; render(); }
    else if (kind === 'picker-size') { S.pickerSize = id; render(); }
    else if (kind === 'picker-showall') { S.pickerShowAll = !S.pickerShowAll; render(); }
    else if (kind === 'add-set') {
      var drawer = S.drawers[parseInt(el.getAttribute('data-drawer'), 10)];
      var set = S.setMap[id];
      if (drawer && set) {
        var slot = placeSet(drawer, set);
        if (slot.reason) setStatus(slot.reason);
        saveBuild(); render();
      }
    }
    else if (kind === 'remove') {
      var dr = S.drawers[parseInt(el.getAttribute('data-drawer'), 10)];
      var uid = parseInt(el.getAttribute('data-uid'), 10);
      if (dr) {
        dr.placements = dr.placements.filter(function (p) { return p.uid !== uid; });
        saveBuild(); render();
      }
    }
  }
  function onInput(e) {
    var el = e.target.closest('[data-cf]');
    if (!el) return;
    var kind = el.getAttribute('data-cf');
    if (kind === 'cat-search') { S.catText = el.value; rerenderKeepFocus(el, render); }
    else if (kind === 'picker-search') { S.pickerText = el.value; rerenderKeepFocus(el, render); }
  }
  function rerenderKeepFocus(el, fn) {
    var attr = el.getAttribute('data-cf'), pos = el.selectionStart;
    fn();
    var again = root.querySelector('[data-cf="' + attr + '"]');
    if (again) { again.focus(); try { again.setSelectionRange(pos, pos); } catch (err) {} }
  }

  /* ---------- boot ---------- */
  function buildBar() {
    bar = document.createElement('div');
    bar.id = 'cf-cart-bar';
    bar.style.display = 'none';
    bar.innerHTML = '<button type="button" id="cf-bar-pill" class="cf-bar-pill" aria-label="Expand toolkit summary">' +
      '<span id="cf-pill-count"></span><strong id="cf-pill-total"></strong><span aria-hidden="true">▾</span></button>' +
      '<div class="cf-cart-bar__inner">' +
      '<div class="cf-cart-bar__meta"><span class="cf-cart-bar__title">Your toolkit</span>' +
      '<button type="button" id="cf-bar-min" class="cf-bar-min" aria-label="Minimise toolkit summary">−</button>' +
      '<span id="cf-cart-count"></span></div>' +
      '<strong id="cf-cart-total" class="cf-cart-bar__total"></strong>' +
      '<div class="cf-bays"><span>Fitting out a shop?</span>' +
      '<span class="cf-bays__ctl"><button type="button" class="cf-bays__btn" data-bays="-1" aria-label="Fewer bays">−</button>' +
      '<span id="cf-bays-n">1 bay</span>' +
      '<button type="button" class="cf-bays__btn" data-bays="1" aria-label="More bays">+</button></span></div>' +
      '<div class="cf-cart-bar__actions"><span id="cf-cart-status" role="status"></span>' +
      '<button type="button" id="cf-cart-add" class="cf-btn cf-btn--red cf-btn--big">Add toolkit to cart</button>' +
      '<button type="button" id="cf-cart-share" class="cf-sharelink">Copy build link — save or share it</button>' +
      '<button type="button" id="cf-cart-restart" class="cf-sharelink cf-sharelink--dim">Start over</button></div></div>';
    document.body.appendChild(bar);
    bar.addEventListener('click', function (e) {
      if (e.target.closest('#cf-bar-min')) { S.barMin = true; syncBarMin(); return; }
      if (e.target.closest('#cf-bar-pill')) { S.barMin = false; syncBarMin(); return; }
      if (e.target.closest('#cf-cart-restart')) {
        if (window.confirm('Start over? This clears your current build.')) {
          clearStorage(); S.path = null; BUILD_ID = mintBuildId(); render(); renderBar();
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        return;
      }
      var bb = e.target.closest('[data-bays]');
      if (bb) {
        S.bays = Math.max(1, Math.min(24, (S.bays || 1) + parseInt(bb.getAttribute('data-bays'), 10)));
        document.getElementById('cf-bays-n').textContent = S.bays + (S.bays === 1 ? ' bay' : ' bays');
        lastTotal = null; renderBar();
        return;
      }
      if (e.target && e.target.id === 'cf-cart-add') addToCart();
      if (e.target && e.target.id === 'cf-cart-share') {
        saveBuild();
        var url = location.href;
        var done = function () { setStatus('Link copied — it reopens this exact build.'); };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(done, function () { window.prompt('Copy this link:', url); });
        } else { window.prompt('Copy this link:', url); }
      }
    });
  }

  function fetchJson(url, label) {
    return fetch(url).then(function (r) {
      if (!r.ok) throw new Error(label + ' failed (' + r.status + ')');
      return r.json();
    });
  }

  /* ---------- pageview beacon ----------
     Self-contained (this asset is not guaranteed to load after the storefront
     pixel, teng-tools/shopify-theme/assets/teng-analytics-pixel.js) — same
     cookie name/shape (sf_vid, sf_sid) so it reuses that pixel's ids when
     present and is still correct standalone when it is not. Same endpoint +
     payload shape as the pixel's own beacon(): POST
     /api/conductor/track/commerce, first-party sf_vid/sf_sid, silent fail,
     no DOM write, no PII collected. */
  function beaconCookie(name, value, days) {
    if (value === undefined) {
      var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
      return m ? decodeURIComponent(m[1]) : null;
    }
    var exp = '';
    if (days) { var d = new Date(); d.setTime(d.getTime() + days * 864e5); exp = '; expires=' + d.toUTCString(); }
    document.cookie = name + '=' + encodeURIComponent(value) + exp + '; path=/; SameSite=Lax';
    return value;
  }
  function beaconUuid() {
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
  }
  function trackKitBuilderView() {
    try {
      var vid = beaconCookie('sf_vid') || beaconCookie('sf_vid', beaconUuid(), 90);
      var sid = beaconCookie('sf_sid') || beaconCookie('sf_sid', beaconUuid(), 0);
      var payload = {
        visitor_id: vid,
        session_id: sid,
        event_type: 'kit_builder_view',
        landing_url: location.href,
        ts: new Date().toISOString()
      };
      if (document.referrer) payload.referrer = document.referrer;
      var url = 'https://simplyfactura-api.fly.dev/api/conductor/track/commerce?sf=teng-usa';
      var body = JSON.stringify(payload);
      if (navigator.sendBeacon) {
        navigator.sendBeacon(url, new Blob([body], { type: 'application/json' }));
      } else {
        fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body, keepalive: true, mode: 'cors' }).catch(function () {});
      }
    } catch (e) { /* never break the kit builder */ }
  }

  function start() {
    root = document.getElementById('cf-root');
    if (!root || !CFG.data) return;
    trackKitBuilderView();
    root.innerHTML = '<div class="cf-app"><p class="cf-empty">Loading the kit builder…</p></div>';
    Promise.all([
      fetchJson(CFG.data.toolStorages, 'storages'),
      fetchJson(CFG.data.toolSets, 'sets'),
      fetchJson(CFG.data.toolKits, 'kits'),
      fetchJson(CFG.skuMapUrl, 'prices'),
      CFG.personaBuildsUrl ? fetchJson(CFG.personaBuildsUrl, 'trades').catch(function () { return null; }) : Promise.resolve(null)
    ]).then(function (r) {
      S.storages = r[0]; S.sets = r[1]; S.kits = r[2]; S.sku = r[3];
      S.trades = (r[4] && r[4].personas) || [];
      S.storages.forEach(function (s2) { S.storageMap[s2.itemId] = s2; });
      S.sets.forEach(function (s2) { S.setMap[s2.itemId] = s2; s2.cat = classify(s2.description); });
      buildBar();
      restoreBuild();
      render();
      root.addEventListener('click', onClick);
      document.addEventListener('click', function (e) {
        var el = e.target.closest('[data-cf="qv-close"]');
        if (el) { closeQuickView(); return; }
        var add = e.target.closest('[data-cf="add-component"]');
        if (add) addComponent(add.getAttribute('data-id'), add);
      });
      root.addEventListener('input', onInput);
    }).catch(function (e) {
      root.innerHTML = '<div class="cf-app"><p class="cf-empty">The kit builder could not load. Please refresh the page.</p></div>';
      if (window.console) console.error('cf-app:', e);
    });
  }

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start) : start();
})();
